import React from 'react';
import { NumericFormat } from 'react-number-format';
import { PercentageInputProps } from './types';

const PercentageInput: React.FC<PercentageInputProps> = ({
  value,
  onValueChange,
  placeholder,
  input,
}) => {
  return (
    <NumericFormat
      value={value}
      decimalScale={2}
      allowNegative={false}
      isAllowed={({ value, floatValue }) => {
        if (!value) return true;
        return floatValue <= 100;
      }}
      onValueChange={({ value }) => {
        const parsed = value === '' ? null : Number(value);
        onValueChange(parsed);
      }}
      customInput={input}
      suffix="%"
      thousandSeparator
      placeholder={placeholder}
    />
  );
};

export default PercentageInput;
